import { createSlice } from '@reduxjs/toolkit'
import { userVerify, fetchTopUsers } from '../actions/userVerifyActions' 


const initialState = {
	userData: null, 
	loading: false,
	error: null, 
	topUsers: [],
	topUsersLoading: false,
	topUsersError: null,
}

const userVerifySlice = createSlice({
	name: 'verify', 
	initialState,
	reducers: {
		resetVerifyState: state => {
			state.userData = null
			state.loading = false
			state.error = null
		},
        resetTopUsersState: state => {
            state.topUsers = [];
            state.topUsersLoading = false;
            state.topUsersError = null;
        },
	},
	extraReducers: builder => {
		builder
			.addCase(userVerify.pending, state => {
				state.loading = true
				state.error = null
				state.userData = null
			})
			.addCase(userVerify.fulfilled, (state, action) => {
				state.loading = false
				state.userData = action.payload 
				state.error = null
			})
			.addCase(userVerify.rejected, (state, action) => {
				state.loading = false
				state.userData = null
				state.error = action.payload 
			})
            .addCase(fetchTopUsers.pending, state => {
                state.topUsersLoading = true;
                state.topUsersError = null;
                state.topUsers = [];
            })
            .addCase(fetchTopUsers.fulfilled, (state, action) => {
                state.topUsersLoading = false;
                state.topUsers = action.payload; 
                state.topUsersError = null;
            })
            .addCase(fetchTopUsers.rejected, (state, action) => {
                state.topUsersLoading = false;
                state.topUsers = [];
                state.topUsersError = action.payload; 
            });
	},
})

export const { resetVerifyState, resetTopUsersState } = userVerifySlice.actions
export default userVerifySlice.reducer
